<template>
  <div>
    <ApuracaoPaginador
      v-if="totalPaginas > 1"
      :pagina="pagina"
      :total="totalPaginas"
      @mudar="mudarPagina"
    />
    <v-data-table
      :headers="headers"
      :items="chassisVendidos"
      hide-default-footer
      disable-pagination
      dense
      style="white-space: nowrap"
    >
      <template v-slot:body>
        <tbody v-if="gruposPagina.length">
          <template v-for="(grupo, gi) in gruposPagina">
            <tr
              v-for="(row, ri) in grupo.rows"
              :key="`${gi}-${ri}`"
              :style="ri === 0 && gi > 0 ? 'border-top: 2px solid rgba(42,87,136,0.12)' : ''"
            >
              <td
                v-if="ri === 0"
                :rowspan="grupo.rows.length"
                style="vertical-align: middle; padding: 4px 10px; border-right: 1px solid rgba(0,0,0,0.08); min-width: 100px; max-width: 140px"
              >
                <div class="caption font-weight-medium d-block">{{ (row.apelido || row.nome_empresa || '').toUpperCase() }}</div>
              </td>
              <td
                v-if="ri === 0"
                :rowspan="grupo.rows.length"
                style="vertical-align: middle; padding: 4px 10px; border-right: 2px solid rgba(42,87,136,0.15); min-width: 130px; max-width: 200px"
              >
                <div class="caption font-weight-bold d-block">{{ row.colaborador }}</div>
                <div class="caption grey--text text--darken-1 d-block" style="font-size: 10px">{{ row.funcao }}</div>
              </td>

              <td style="padding: 2px 10px">
                <span class="caption font-weight-medium d-block" style="font-family: monospace">{{ row.chassi_completo }}</span>
                <span v-if="row.chassi_resumido" class="caption grey--text" style="font-size: 11px">{{ row.chassi_resumido }}</span>
              </td>

              <td class="text-end" style="padding: 2px 10px; white-space: nowrap">
                {{ formatarRealizado(row) }}
              </td>
              <td class="text-end" style="padding: 2px 10px; white-space: nowrap">
                {{ row.valor_bonus | BrazilianCurrency }}
              </td>
              <td class="text-end" style="padding: 2px 10px; white-space: nowrap">
                {{ row.valor_bonus_apurado | BrazilianCurrency }}
              </td>
              <td class="text-end" style="padding: 2px 10px">
                <IconGanhou :ganhou="row.ganhou_meta" />
              </td>
              <td class="text-end" style="padding: 2px 10px; white-space: nowrap">
                <span :class="statusPagamento(row).valorClass">{{ row.valor_bonus_pagamento | BrazilianCurrency }}</span>
                <v-chip
                  v-if="statusPagamento(row).chip"
                  x-small
                  :color="statusPagamento(row).chip.color"
                  :class="['ml-1 font-weight-bold', statusPagamento(row).chip.textColor]"
                >{{ statusPagamento(row).chip.text }}</v-chip>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan="headers.length" class="text-center grey--text py-4">Nenhum chassi vendido</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import currencyMixin from "@/mixins/currencyMixin";
import apuracaoTabelaMixin from "@/mixins/apuracaoTabelaMixin";

export default {
  name: "ApuracaoTabelaChassi",

  components: {
    ApuracaoPaginador: () => import("./ApuracaoPaginador"),
    IconGanhou: () => import("@/components/shared/icons/Ganhou")
  },

  mixins: [currencyMixin, apuracaoTabelaMixin],

  data() {
    return {
      headers: [
        { text: "Empresa",       value: "empresa",               sortable: false },
        { text: "Colaborador",   value: "colaborador",            sortable: false },
        { text: "Chassi",        value: "chassi_completo",        sortable: true  },
        { text: "Realizado",     value: "valor_realizado",        sortable: true  },
        { text: "Bônus Unit.",   value: "valor_bonus",            sortable: true  },
        { text: "Bônus Apurado", value: "valor_bonus_apurado",    sortable: true  },
        { text: "Meta",          value: "ganhou_meta",            sortable: false },
        { text: "Bônus Pago",    value: "valor_bonus_pagamento",  sortable: true  }
      ]
    };
  },

  computed: {
    // Pagina sobre os chassis vendidos + linhas sintéticas dos sem-venda.
    linhasBase() {
      return this.chassisVendidos;
    },

    chassisVendidos() {
      const vendidos = this.rows.filter(r => parseFloat(r.valor_realizado) > 0);

      // colaboradores sem nenhuma venda: uma linha sintética por colaborador
      const comVenda = new Set(vendidos.map(r => r.id_colaborador ?? r.colaborador));
      const vistos = new Set();
      const semVenda = [];
      for (const row of this.rows) {
        const key = row.id_colaborador ?? row.colaborador;
        if (comVenda.has(key) || vistos.has(key)) continue;
        vistos.add(key);
        semVenda.push({
          ...row,
          chassi_completo: "",
          chassi_resumido: "",
          valor_realizado: 0,
          valor_bonus: 0,
          valor_bonus_apurado: 0,
          valor_bonus_pagamento: 0,
          ganhou_item: false,
          ganhou_meta: false
        });
      }

      return [...vendidos, ...semVenda];
    }
  }
};
</script>
